<div [ngClass]="{ 'confirm-dialog': !externalClass || !externalClass.length, externalClass: externalClass && externalClass.length }">
    <div class="dialog-content">
        {{ message }}
        <ng-content></ng-content>
    </div>
    @switch (dialogType) { @case (dialogTypeEnum.confirm) {
    <div class="dialog-actions">
        <por-base-button (onclick)="sendPrompt(false)">
            <span>{{ 'no' | translate }}</span>
        </por-base-button>
        <por-base-button (onclick)="sendPrompt(true)">
            <span>{{ 'yes' | translate }}</span>
        </por-base-button>
    </div>
    } @default {
    <div class="dialog-actions">
        <por-base-button (onclick)="sendPrompt(false)">
            <span>{{ 'ok' | translate }}</span>
        </por-base-button>
    </div>
    } }
</div>
